import { getKey, getMediaCardSSR } from './globalScope';
export const getSSRData = identifier => {
  const mediaCardSsr = getMediaCardSSR();
  if (!mediaCardSsr) {
    return;
  }
  return mediaCardSsr[getKey(identifier)];
};